<form class="notify-template-form ups-form"
      [formGroup]="formGroup"
      (ngSubmit)="onFormSubmit($event, formGroup.value)">
    <div class="form-body">
        <input type="hidden"
               formControlName="ppiTemplateName">
        <mat-form-field>
            <mat-label>{{ 'notifyTemplates.templateTitle'|translate }}</mat-label>
            <input required
                   matInput
                   formControlName="templateTitle">
            <mat-error *ngIf="formGroup.controls.templateTitle?.errors">
            <span *ngIf="formGroup.controls.templateTitle?.errors?.required">
                <span>{{ 'notifyTemplates.templateTitleRequired'|translate }}</span>
            </span>
            </mat-error>
        </mat-form-field>
        <mat-form-field>
            <mat-label>{{ 'notifyTemplates.websiteURL'|translate }}</mat-label>
            <input matInput
                   formControlName="websiteUrl">
            <mat-error>
                @if (formGroup.controls.websiteUrl?.errors?.invalidFormat) {
                    <span>The value must be a URL.</span>
                } @else if (formGroup.controls.websiteUrl?.errors?.invalidUrlFormat) {
                    <span>URL must start with <strong>http://</strong> or <strong>https://</strong>.</span>
                } @else if (formGroup.controls.websiteUrl?.errors?.invalidEmailFormat) {
                    <span>Email address must start with <strong>mailto:</strong></span>
                }
            </mat-error>
        </mat-form-field>

        <div class="template-images">
            <h6 class="section-title">{{ 'notifyTemplates.coverImage'|translate }}</h6>
            <p>{{ 'notifyTemplates.coverPhotoDesc'|translate }}</p>

            <div class="cover-image-wrapper">
                <div class="image-selector">
                    <label class="mat-mdc-raised-button">
                        {{ 'notifyTemplates.uploadPhoto'|translate }}
                        <input #coverImageInput
                               type="file"
                               class="hide"
                               accept="image/jpeg, image/png"
                               (change)="onCoverImageSelected($event)">
                    </label>
                </div>
                <div class="image-item"
                     *ngIf="coverImageFileName">
                    <span class="file-name"
                          matTooltip="{{ coverImageFileName }}"
                          matTooltipPosition="above">{{ coverImageFileName }}</span>
                    <button mat-button
                            color="warn"
                            type="button"
                            (click)="removeCoverImage($event)">{{ 'notifyTemplates.REMOVE'|translate }}
                    </button>
                </div>
                <upsc-element-blocker *ngIf="isCoverImageUploading"></upsc-element-blocker>
                @if (!isCoverImageValid) {
                    <mat-error>Only .jpg and .png files are supported.</mat-error>
                }
            </div>

            <h6 class="section-title">{{ 'notifyTemplates.bannerImage'|translate }}</h6>
            <p>{{ 'notifyTemplates.bannerPhotoDesc'|translate }}</p>

            <div class="banner-image-wrapper">
                <div class="image-selector">
                    <label class="mat-mdc-raised-button">
                        {{ 'notifyTemplates.uploadPhoto'|translate }}
                        <input #bannerImageInput
                               type="file"
                               class="hide"
                               accept="image/jpeg, image/png"
                               (change)="onBannerImageSelected($event)">
                    </label>
                </div>
                <div class="image-item"
                     *ngIf="bannerImageFileName">
                    <span class="file-name"
                          matTooltip="{{ bannerImageFileName }}"
                          matTooltipPosition="above">{{ bannerImageFileName }}</span>
                    <button mat-button
                            color="warn"
                            type="button"
                            (click)="removeBannerImage($event)">{{ 'notifyTemplates.REMOVE'|translate }}
                    </button>
                </div>
                <upsc-element-blocker *ngIf="isBannerImageUploading"></upsc-element-blocker>
                @if (!isBannerImageValid) {
                    <mat-error>Only .jpg and .png files are supported.</mat-error>
                }
            </div>

            <div class="showcase-images-wrapper">
                <mat-checkbox (change)="isAddShowcasePhotosEnabled = !isAddShowcasePhotosEnabled"
                              formControlName="shouldDisplayShowcaseImages">
                    {{ 'notifyTemplates.addShowcasePhotos'|translate }}
                </mat-checkbox>

                <div class="image-selector showcase"
                     *ngIf="isAddShowcasePhotosEnabled">
                    <label class="mat-mdc-raised-button"
                           [class.disabled]="showcaseImageFileNames.length >= 3">
                        {{ 'notifyTemplates.uploadPhotos'|translate }}
                        <input #showcaseImageInput
                               type="file"
                               class="hide"
                               accept="image/jpeg, image/png"
                               (change)="onShowcaseImagesSelected($event)">
                    </label>

                    <div class="image-item"
                         *ngFor="let fileName of showcaseImageFileNames">
                        <span class="file-name"
                              matTooltip="{{ fileName }}"
                              matTooltipPosition="above">{{ fileName }}</span>
                        <button mat-button
                                color="warn"
                                type="button"
                                (click)="removeShowcaseImage($event, fileName)">
                            {{ 'notifyTemplates.REMOVE'|translate }}
                        </button>
                    </div>
                    <upsc-element-blocker *ngIf="isShowcaseImageUploading"></upsc-element-blocker>
                    @if (!isShowcaseImageValid) {
                        <mat-error>Only .jpg and .png files are supported.</mat-error>
                    }
                </div>
            </div>
        </div>

        <div class="divider"></div>
       <mat-checkbox formControlName="isTermsAgreed" class="terms">
            {{ 'notifyTemplates.agreeToParcelPro'|translate }} <a [href] ="termsOfUseURL"
                target="_blank">
                <span *ngIf="!isLang('FR')">{{ 'TermsOfUse'|translate }}</span>
                <span *ngIf="isLang('FR')">{{ 'notifyTemplates.TermsOfUse'|translate }}</span>
            </a>&nbsp;<span *ngIf="isLang('FR') || isLang('IT')">{{'notifyTemplates.TermsOfUseMessage'|translate}}</span>
        </mat-checkbox>

        </div>

    <div class="form-footer">
        <div class="form-actions">
            <button type="submit"
                    mat-raised-button
                    color="primary"
                    [disabled]="!formGroup.valid">{{ 'Create'|translate }}
            </button>
        </div>
    </div>
</form>
